<template>
    <div>
        <div v-for="(comment, i) in comments" :key="i">
            <h6 class="mr-auto">
                {{
                    comment.$model.title +
                        (comment.$model.is_required ? '*' : '')
                }}
            </h6>
            <comment-field
                v-if="isEditing"
                :toolbar="toolbar"
                :value.sync="comment.content.$model"
                :disabled="
                    isLoading(
                        comment.$model.questionnaire_comment_id,
                        'creating'
                    )
                "
                :state="checkState(comment.content)"
                @change-debounced="onUpdateCommentContent(comment.$model)"
            >
                <span>
                    {{ $t('form.validations.required') }}
                </span>
            </comment-field>
            <div
                v-else
                class="text-justify"
                v-html="comment.$model.content ? comment.$model.content : '-'"
            />
            <div class="d-flex">
                <div class="text-primary">
                    <transition name="fade-autosave">
                        <div
                            v-if="
                                isLoading(
                                    comment.$model.questionnaire_comment_id,
                                    'updating'
                                )
                            "
                        >
                            <i class="fa fa-spinner fa-spin px-2" />
                            <span>
                                {{ $t('values.updatingComment') }}
                            </span>
                        </div>
                        <div
                            v-if="
                                isLoading(
                                    comment.$model.questionnaire_comment_id,
                                    'creating'
                                )
                            "
                        >
                            <i class="fa fa-spinner fa-spin px-2" />
                            <span>
                                {{ $t('values.savingComment') }}
                            </span>
                        </div>
                        <div
                            v-if="
                                isLoading(
                                    comment.$model.questionnaire_comment_id,
                                    'afterUpdate'
                                )
                            "
                            class="ml-2"
                        >
                            <i class="fas fa-save fa-lg pr-2" />
                            <span>
                                {{ $t('values.changesSaved') }}
                            </span>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Description } from '@/views/components/fields'
import { createComment, updateComment } from '@/views/values/api'

export default {
    props: {
        comments: {
            type: Array,
            required: true,
        },
        evaluationId: {
            type: Number,
            required: true,
        },
        isEditing: {
            type: Boolean,
            required: true,
        },
    },
    components: {
        CommentField: Description,
    },
    data() {
        return {
            loaders: {},
            toolbar: [
                'bold',
                'italic',
                'underline',
                'strike',
                { list: 'ordered' },
                { list: 'bullet' },
            ],
        }
    },
    methods: {
        checkState(value) {
            if (!this.isEditing) {
                return null
            }
            return value.$dirty ? !value.$invalid : null
        },
        getCommentLoaderKey(questionnaireCommentId) {
            return this.evaluationId + '-' + questionnaireCommentId
        },
        isLoading(questionnaireCommentId, operation) {
            const key = this.getCommentLoaderKey(questionnaireCommentId)
            return this.loaders[key] ? this.loaders[key][operation] : false
        },
        setLoader({
            creating = false,
            updating = false,
            afterUpdate = false,
            questionnaireCommentId,
        }) {
            const key = this.getCommentLoaderKey(questionnaireCommentId)
            this.$set(this.loaders, key, { creating, updating, afterUpdate })
        },
        async onUpdateCommentContent(comment) {
            let currentFocusedComment = document.activeElement

            this.setLoader({
                creating: comment.id == null,
                updating: comment.id != null,
                questionnaireCommentId: comment.questionnaire_comment_id,
            })

            const payload = {
                content: comment.content,
                evaluation_id: this.evaluationId,
                commentable_type: 'questionnaire_has_comment',
                commentable_id: comment.questionnaire_comment_id,
            }

            if (comment.id == null) {
                await createComment(payload).then(newComment => {
                    comment.id = newComment.id
                })
            } else {
                await updateComment(comment.id, payload)
            }

            this.setLoader({
                questionnaireCommentId: comment.questionnaire_comment_id,
                afterUpdate: true,
            })

            setTimeout(() => {
                this.setLoader({
                    questionnaireCommentId: comment.questionnaire_comment_id,
                })
            }, 3000)

            setTimeout(() => {
                currentFocusedComment.focus()
            }, 1)
        },
    },
}
</script>
<style lang="sass" scoped>
.ql-editor
    min-height: 120px !important;
</style>
